<template>
  <div class="text-center" data-testid="verify-email-success">
    <h1 id="verify-email-heading" class="text-h3">Email verified</h1>
    <p class="text-body mt-16">Your email has been verified. Now, let's continue where you left off.</p>
    <div class="mt-32 flex justify-center">
      <Button
        data-testid="verify-email-resume"
        :value="resumeLabel"
        size="medium"
        class="w-full sm:w-auto"
        @click="emit('continue')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from '@/components/button/Button.vue';

defineOptions({ name: 'VerifyEmailSuccess' });

withDefaults(
  defineProps<{
    resumeLabel?: string;
  }>(),
  {
    resumeLabel: 'Continue',
  }
);

const emit = defineEmits<{
  continue: [];
}>();
</script>
